// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__19Zm9","fileBtn":"File_fileBtn__ocvD_","closeBtn":"File_closeBtn__riBDS","fileSelected":"File_fileSelected__12Q4K","disabled":"File_disabled__1JJWQ"};